import "core-js/modules/es.date.to-json.js";
export function useLoginProvider() {
  var handleGoogleLogin = function handleGoogleLogin() {
    localStorage.setItem("isGoogleLogin", JSON.stringify(true));
    var SSO_REDIRECT_URI = window.location.origin;
    // eslint-disable-next-line max-len
    var GOOGLE_SSO_LINK = "https://accounts.google.com/o/oauth2/v2/auth?response_type=code&redirect_uri=".concat(SSO_REDIRECT_URI, "/rest/sso/google&client_id=150725646086-0doo80vlsenpekc47k882ki3ldp6ol54.apps.googleusercontent.com&scope=https://www.googleapis.com/auth/userinfo.email&access_type=offline&prompt=consent");
    window.open(GOOGLE_SSO_LINK, "GoogleSso", "status=no,menubar=no,toolbar=no,width=800,height=600,top=100,left=100");
  };
  return {
    handleGoogleLogin: handleGoogleLogin
  };
}